/**
 * Brightness Style01 - Slider style for Smart Home modal
 * min/max from attributes.brightnessRange
 */
import { useState, useEffect, useMemo } from 'react'
import type { TraitControlProps } from './types'
import { resolveRangeFromAttributes } from './traitStyleConfig'
import './BrightnessStyle01.css'

export function BrightnessStyle01({
  trait,
  state,
  attributes,
  onCommand,
  disabled = false,
}: TraitControlProps) {
  const { min: MIN, max: MAX } = useMemo(
    () => resolveRangeFromAttributes(attributes, trait, 'brightness'),
    [attributes, trait]
  )
  const rawBrightness = Number(state?.brightness)
  const currentBrightness = Number.isFinite(rawBrightness)
    ? Math.max(MIN, Math.min(MAX, Math.round(rawBrightness)))
    : Math.round((MIN + MAX) / 2)
  const [brightness, setBrightness] = useState(currentBrightness)

  useEffect(() => {
    const raw = Number(state?.brightness)
    const v = Number.isFinite(raw) ? Math.max(MIN, Math.min(MAX, Math.round(raw))) : Math.round((MIN + MAX) / 2)
    setBrightness(v)
  }, [state?.brightness, MIN, MAX])

  const handleChange = (value: number) => {
    const safeValue = Math.max(MIN, Math.min(MAX, Math.round(value)))
    setBrightness(safeValue)
    void onCommand('setBrightness', { brightness: safeValue })
  }

  return (
    <div className="trait-brightness-style01">
      <label htmlFor="brightness-style01-slider" className="trait-brightness-style01__label">
        Brightness
      </label>
      <input
        id="brightness-style01-slider"
        type="range"
        min={MIN}
        max={MAX}
        value={brightness}
        aria-label="Brightness"
        style={{
          background: `linear-gradient(to right, #facc15 0%, #facc15 ${((brightness - MIN) / (MAX - MIN)) * 100}%, rgba(255,255,255,0.20) ${((brightness - MIN) / (MAX - MIN)) * 100}%, rgba(255,255,255,0.20) 100%)`,
          accentColor: '#facc15',
        }}
        onChange={(e) => setBrightness(Number(e.target.value))}
        onMouseUp={(e) => handleChange(Number((e.target as HTMLInputElement).value))}
        onTouchEnd={(e) => handleChange(Number((e.target as HTMLInputElement).value))}
        className="trait-brightness-style01__slider"
        disabled={disabled}
      />
      <span className="trait-brightness-style01__value">{brightness}%</span>
    </div>
  )
}
